export const surveyJson = {
  title: {
    default: "Test survey",
    es: "Cuestionario de prueba",
  },
  description: {
    default: "This is a test survey to test the functionality in a React app.",
    es: "Este es un cuestionario de prueba",
  },
  logoPosition: "right",
  completedHtml: {
    default:
      "<h3>The recommended methodology for you to apply is the following:</h3>",
    es: "<h3>La metodología recomendada para aplicar es la siguiente</h3>",
  },
  pages: [
    {
      name: "intro",
      readOnly: true,
      title: {
        es: "Página de inicio",
      },
      elements: [
        {
          type: "html",
          name: "question1",
          html: {
            default:
              '<div class="text-center"><h4 class="mb-2 text-[#86E1C3] dark:text-[#FF9814]">Strategy for Transnational Methodology for Online Self-Assessment Tool\n</h4><p class="text-justify">The Circular WEEEP Self-assessment Tools are designed to evaluate the impact of WEEE (Waste Electrical and Electronic Equipment) management from a circular economy (CE) perspective. These tools are based on a sustainable product design model for WEEE, aiming to minimize waste and empower consumers. The instruments involve interactions that promote sustainability and circularity among industries, authorities, practitioners, and communities. They encompass the fundamental principles of the CE model, including sharing, leasing, reuse, repair, refurbishing, collecting and recycling. These principles serve as guidelines for decision-making at all levels and define the objectives that a sustainable and circular WEEE management system should strive to achieve. Cooperation among actors involved in WEEE management is seen as a crucial factor in supporting the implementation of all CE WEEE principles.\n<br/>\n<br/>\nThe benefits of using the Circular WEEEP Tools include enhancing awareness of opportunities and weaknesses, meeting the growing demand for environmentally conscious products from consumers, minimizing environmental impact, developing new skills and knowledge to facilitate the transition to a new circular business model in WEEE, improving collaboration with stakeholders, and providing innovative and circular services by adopting a life cycle perspective. This assessment will help users understand their sustainable and circular performance, identify areas to enhance the competitiveness and resilience of their products and business, and improve networking by involving all relevant stakeholders in the circular transition of WEEE.\n<br/>\n<br/>\n</p>\n<p class="text-justify" style="font-weight: 600;">\nThe Online Self-Assessment Tool has been developed in the first half of 2024, so for that reason the information included in the report generated at the end of this self-assessment questionnaire corresponds to the information collected before July 2024.\n</p>\n<br/>\n<br/>\n<p><b>Privacy Disclaminer:</b> Your privacy is important to us. We assure you that any data provided will not be stored on our platform, shared, or used by any third parties. Once the session is completed, all data will be permanently deleted.</p></div>',
            es: '<div class="text-center"><h4 class="mb-2 text-[#86E1C3] dark:text-[#FF9814]">Bienvenido a la herramienta online de autoevaluación del Proyecto Circular WEEEP</h4><p class="text-justify">Con este formulario podrás obtener la metodología recomendada a aplicar en función de las respuestas dadas en el siguiente formulario.Para comenzar, haga clic en el botón de inicio.</p></div>',
          },
        },
      ],
    },
    {
      name: "general_questions",
      title: "General Questions",
      elements: [
        {
          type: "text",
          name: "organization_name",
          title: "What is the name of your organization?",
          isRequired: true,
          maxLength: 500,
        },
        {
          type: "dropdown",
          name: "group",
          title: "What group does your organization belongs",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Circular Producer",
            },
            {
              value: "Item 2",
              text: "Circular User",
            },
            {
              value: "Item 3",
              text: "Circular Re-user",
            },
            {
              value: "Item 4",
              text: "Public Administration",
            },
          ],
        },
        {
          type: "dropdown",
          name: "country",
          title: "Select the country of where your organizations belongs",
          isRequired: true,
          choices: [
            "Croatia",
            "Italy",
            "Poland",
            "Slovakia",
            "Slovenia",
            {
              value: "Czech_Republic",
              text: "Czech Republic",
            },
          ],
          otherText: "Other",
        },
      ],
    },
    {
      name: "specific_page1",
      title:
        "Evaluation of WEEE Recycling Practices and Their Impact on the Studied Area",
      elements: [
        {
          type: "comment",
          name: "specific_18",
          visibleIf: "{country} = 'Czech_Republic'",
          title: "Please describe the legal Framework in Chequia.",
          isRequired: true,
          requiredIf: "{country} = 'Czech_Republic'",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "comment",
          name: "specific_4",
          title:
            "In your area, and based on your perspective, what specific challenges do rural areas face in terms of WEEE management compared to urban areas?",
          isRequired: true,
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "dropdown",
          name: "specific_19",
          title:
            "As a user, how many outdated devices do you believe you have in your home that should be collected?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Very High (>15)",
            },
            {
              value: "Item 2",
              text: "High (>10)",
            },
            {
              value: "Item 3",
              text: "Medium (Around 5)",
            },
            {
              value: "Item 4",
              text: "Low (Around 2)",
            },
            {
              value: "Item 5",
              text: "Very Low (1 or None) ",
            },
          ],
        },
        {
          type: "comment",
          name: "specific_5",
          title:
            "In your area, and based on your perspective, which electronic devices do you estimate are currently unrecovered and stored in homes, contributing to the WEEE problem?",
          isRequired: true,
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "matrixdropdown",
          name: "specific_6",
          title:
            "In your area, and based on your perspective, what is the correlation between public awareness campaigns and WEEE collecting? ",
          isRequired: true,
          columns: [
            {
              name: "Value",
              title: "Correlation",
              isRequired: true,
            },
          ],
          choices: ["Very high", "High", "Low", "Very low"],
          rows: [
            {
              value: "Row 1",
              text: "Public awareness campaigns",
            },
            {
              value: "Row 2",
              text: "WEEE collecting",
            },
          ],
        },
        {
          type: "dropdown",
          name: "specific_20",
          title:
            "In your area, and based on your perspective, do you consider that there are enough WEEE collection points across the studied area? Please select the intensity.",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Very sufficient",
            },
            {
              value: "Item 2",
              text: "Sufficient",
            },
            {
              value: "Item 3",
              text: "Insufficient",
            },
            {
              value: "Item 4",
              text: "Very insufficient",
            },
          ],
        },
        {
          type: "comment",
          name: "specific_7",
          title:
            "In your area, and based on your perspective, describe how the WEEE collection points are distributed in your area.",
          isRequired: true,
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "dropdown",
          name: "specific_21",
          title:
            "How significant is the issue of illegal disposal of WEEE in your area, and what measures are being taken to combat it? Please select the significance level.",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Very significant",
            },
            {
              value: "Item 2",
              text: "Significant",
            },
            {
              value: "Item 3",
              text: "Insignificant",
            },
            {
              value: "Item 4",
              text: "Very insignificant",
            },
          ],
        },
        {
          type: "comment",
          name: "specific_8",
          title:
            "Describe the measures being taken to combat the illegal disposal of WEEE in your area.",
          isRequired: true,
          maxLength: 5000,
          autoGrow: true,
        },
      ],
    },
    {
      name: "specific_page2",
      title: "Economic Impact",
      elements: [
        {
          type: "dropdown",
          name: "specific_22",
          title:
            "Do you consider that the economic incentives provided to encourage businesses and individuals to participate in WEEE collecting programs in your area are sufficient?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Very sufficient",
            },
            {
              value: "Item 2",
              text: "Sufficient",
            },
            {
              value: "Item 3",
              text: "Insufficient",
            },
            {
              value: "Item 4",
              text: "Very insufficient",
            },
          ],
        },
        {
          type: "comment",
          name: "specific_9",
          title:
            "In your area, and based on your perspective, describe the problems or positive points regarding the current economic incentives for WEEE collecting programs.",
          isRequired: true,
          maxLength: 5000,
          autoGrow: true,
        },
      ],
    },
    {
      name: "specific_page3",
      title: "WEEE Policy Instrument in the Studied Area",
      elements: [
        {
          type: "radiogroup",
          name: "specific_10",
          title:
            "At what level does the action plan primarily operate to manage WEEE.",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "National",
            },
            {
              value: "Item 2",
              text: "Regional",
            },
            {
              value: "Item 3",
              text: "Local",
            },
          ],
        },
        {
          type: "comment",
          name: "specific_11",
          visibleIf: "{specific_10} anyof ['Item 2', 'Item 3']",
          title: "Describes the geography of the area.",
          requiredIf: "{specific_10} anyof ['Item 2', 'Item 3']",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "comment",
          name: "specific_12",
          title:
            "What is the current situation regarding the problematic in the area, and what challenges need to be overcome in this territory?",
          isRequired: true,
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "specific_13",
          title:
            "Is there any specific policy instrument related to WEEE management in your area? ",
          isRequired: true,
        },
        {
          type: "comment",
          name: "specific_13_comment",
          visibleIf: "{specific_13} = true",
          title: "Please indicate the name of the Policy Instrument.",
          hideNumber: true,
          requiredIf: "{specific_13} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "comment",
          name: "specific_14",
          visibleIf: "{specific_13} = true",
          title:
            "Please describe the main features of this policy instrument (e.g. objective, characteristics, priority or measure addressed).",
          isRequired: true,
          requiredIf: "{specific_13} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "comment",
          name: "specific_15",
          visibleIf: "{specific_13} = true",
          title:
            "What kind of improvements do you think that can be implemented for this instrument?",
          isRequired: true,
          requiredIf: "{specific_13} = true",
          maxLength: 5000,
          autoGrow: true,
        },
      ],
    },
    {
      name: "specific_page5",
      title:
        "Evaluation of WEEE Recycling Practices and Their Impact on the Studied Area",
      elements: [
        {
          type: "checkbox",
          name: "specific_1",
          title:
            "What are the most commonly collected types of WEEE in the studied area?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Large household appliance",
            },
            {
              value: "Item 2",
              text: "Small household appliance",
            },
            {
              value: "Item 3",
              text: "IT and telecommunications equipments",
            },
            {
              value: "Item 4",
              text: "Consumer Equipment",
            },
            {
              value: "Item 5",
              text: "Lighting equipment",
            },
            {
              value: "Item 6",
              text: "Electrical and electronic tools",
            },
            {
              value: "Item 7",
              text: "Toys, leisure and sports equipment",
            },
            {
              value: "Item 8",
              text: "Medical devices",
            },
            {
              value: "Item 9",
              text: "Monitoring and control instruments",
            },
            {
              value: "Item 10",
              text: "Automatic dispensers",
            },
          ],
          colCount: 2,
        },
        {
          type: "matrixdropdown",
          name: "specific_2",
          title:
            "Indicate, the percentage, of the amount (weight) of the previous items collected. Please note that the total must be 100%.",
          isRequired: true,
          validators: [
            {
              type: "expression",
              text: "The sum of the values must be equal to 100%",
              expression:
                "{specific_2.item1.Value}+{specific_2.item2.Value}+{specific_2.item3.Value}+{specific_2.item4.Value}+{specific_2.item5.Value}+{specific_2.item6.Value}+{specific_2.item7.Value}+{specific_2.item8.Value}+{specific_2.item9.Value}+{specific_2.item10.Value} = 100",
            },
          ],
          columns: [
            {
              name: "Value",
              title: "Percentage",
              cellType: "text",
              isRequired: true,
              validators: [
                {
                  type: "regex",
                  text: "Only integer values are allowed",
                  regex: "^[0-9]*$",
                },
              ],
              totalType: "sum",
              totalDisplayStyle: "decimal",
              inputType: "number",
              min: 0,
              max: 100,
              step: 5,
            },
          ],
          cellType: "text",
          rows: [
            {
              value: "item1",
              text: "Large household appliance",
              visibleIf: "{specific_1} contains 'Item 1'",
            },
            {
              value: "item2",
              text: "Small household appliance",
              visibleIf: "{specific_1} contains 'Item 2'",
            },
            {
              value: "item3",
              text: "IT and telecommunications equipments",
              visibleIf: "{specific_1} contains 'Item 3'",
            },
            {
              value: "item4",
              text: "Consumer Equipment",
              visibleIf: "{specific_1} contains 'Item 4'",
            },
            {
              value: "item5",
              text: "Lighting equipment",
              visibleIf: "{specific_1} contains 'Item 5'",
            },
            {
              value: "item6",
              text: "Electrical and electronic tools",
              visibleIf: "{specific_1} contains 'Item 6'",
            },
            {
              value: "item7",
              text: "Toys, leisure and sports equipment",
              visibleIf: "{specific_1} contains 'Item 7'",
            },
            {
              value: "item8",
              text: "Medical devices",
              visibleIf: "{specific_1} contains 'Item 8'",
            },
            {
              value: "item9",
              text: "Monitoring and control instruments",
              visibleIf: "{specific_1} contains 'Item 9'",
            },
            {
              value: "item10",
              text: "Automatic dispensers",
              visibleIf: "{specific_1} contains 'Item 10'",
            },
          ],
        },
        {
          type: "matrixdropdown",
          name: "specific_3",
          title:
            "What is the material that constitutes the highest percentage by weight in the collected WEEE in your area?",
          isRequired: true,
          columns: [
            {
              name: "Value",
              title: "Percentage",
              cellType: "text",
              isRequired: true,
              validators: [
                {
                  type: "regex",
                  text: "Only integer values are allowed",
                  regex: "^[0-9]*$",
                },
              ],
              totalDisplayStyle: "decimal",
              inputType: "number",
              min: 0,
              max: 100,
              step: 5,
            },
          ],
          cellType: "text",
          rows: [
            {
              value: "item1",
              text: "Metals",
            },
            {
              value: "item2",
              text: "Plastic",
            },
            {
              value: "item3",
              text: "Glass and ceramics",
            },
            {
              value: "item4",
              text: "Other materials (lithium, manganese, nickel etc)",
            },
          ],
        },
        {
          type: "checkbox",
          name: "specific_16",
          title:
            "What are the different methods you think that are used for WEEE recycling in your area?",
          isRequired: true,
          choices: [
            {
              value: "item1",
              text: "Manual Dismantling",
            },
            {
              value: "item2",
              text: "Mechanical Processing (Shredding, Magnetic Separation, Density Separation etc)",
            },
            {
              value: "item3",
              text: "Chemical Processing (Leaching, Electrochemical Processes etc)",
            },
            {
              value: "item4",
              text: "Thermal Processing (Incineration, Pyrolysis etc)",
            },
            {
              value: "item5",
              text: "Biological Processing (Utilizes bacteria or fungi to extract metals from e-waste)",
            },
            {
              value: "item6",
              text: "Hydrometallurgical Processes (using organic solvents to separate specific metals)",
            },
            {
              value: "item7",
              text: "Advanced Sorting Technologies (Uses sensors, cameras, X-RAY to identify and separate materials based on their composition and properties)",
            },
            {
              value: "item8",
              text: "Recycling of Specific Components (as batteries)",
            },
            {
              value: "item9",
              text: "Re-use and Refurbishment (repairing, upgrading or re use the devices)",
            },
          ],
          colCount: 2,
        },
        {
          type: "matrixdropdown",
          name: "specific_17",
          title:
            "Indicate the percentage of the previous selected methods used for WEEE recycling in your area. Please note that the total must be 100%.",
          isRequired: true,
          validators: [
            {
              type: "expression",
              text: "The sum of the values must be equal to 100%",
              expression:
                "{specific_17.item1.Value}+{specific_17.item2.Value}+{specific_17.item3.Value}+{specific_17.item4.Value}+{specific_17.item5.Value}+{specific_17.item6.Value}+{specific_17.item7.Value}+{specific_17.item8.Value}+{specific_17.item9.Value}+{specific_17.item10.Value} = 100",
            },
          ],
          columns: [
            {
              name: "Value",
              title: "Percentage",
              cellType: "text",
              isRequired: true,
              validators: [
                {
                  type: "regex",
                  text: "Only integer values are allowed",
                  regex: "^[0-9]*$",
                },
              ],
              totalType: "sum",
              totalDisplayStyle: "decimal",
              inputType: "number",
              min: 0,
              max: 100,
              step: 5,
            },
          ],
          cellType: "text",
          rows: [
            {
              value: "item1",
              text: "Manual Dismantling",
              visibleIf: "{specific_16} contains 'item1'",
            },
            {
              value: "item2",
              text: "Mechanical Processing (Shredding, Magnetic Separation, Density Separation etc)",
              visibleIf: "{specific_16} contains 'item2'",
            },
            {
              value: "item3",
              text: "Chemical Processing (Leaching, Electrochemical Processes etc)",
              visibleIf: "{specific_16} contains 'item3'",
            },
            {
              value: "item4",
              text: "Thermal Processing (Incineration, Pyrolysis etc)",
              visibleIf: "{specific_16} contains 'item4'",
            },
            {
              value: "item5",
              text: "Biological Processing (Utilizes bacteria or fungi to extract metals from e-waste)",
              visibleIf: "{specific_16} contains 'item5'",
            },
            {
              value: "item6",
              text: "Hydrometallurgical Processes (using organic solvents to separate specific metals)",
              visibleIf: "{specific_16} contains 'item6'",
            },
            {
              value: "item7",
              text: "Advanced Sorting Technologies (Uses sensors, cameras, X-RAY to identify and separate materials based on their composition and properties)",
              visibleIf: "{specific_16} contains 'item7'",
            },
            {
              value: "item8",
              text: "Recycling of Specific Components (as batteries)",
              visibleIf: "{specific_16} contains 'item8'",
            },
            {
              value: "item9",
              text: "Re-use and Refurbishment (repairing, upgrading or re use the devices)",
              visibleIf: "{specific_16} contains 'item9'",
            },
          ],
        },
      ],
    },
    {
      name: "producer_page1",
      visibleIf: "{group} = 'Item 1'",
      title:
        "The Circular Producer · Level 1: Organizational structure and policy",
      elements: [
        {
          type: "checkbox",
          name: "producer_question1",
          title: "Do you implement:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Environmental management",
            },
            {
              value: "Item 2",
              text: "Health and safety",
            },
            {
              value: "Item 3",
              text: "Quality management",
            },
          ],
          separateSpecialChoices: true,
          showNoneItem: true,
        },
        {
          type: "checkbox",
          name: "producer_question2",
          title:
            "Do you comply to current legislation and best practices for managing hazardous components and waste, which includes:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "WEEE Directive",
            },
            {
              value: "Item 2",
              text: "Batteries and Accumulators Directive",
            },
            {
              value: "Item 3",
              text: "RoHS Directive",
            },
            {
              value: "Item 4",
              text: "Eco-design Directive",
            },
            {
              value: "Item 5",
              text: "REACH Regulation",
            },
            {
              value: "Item 6",
              text: "Basel Convention",
            },
            {
              value: "Item 7",
              text: "Greenhouse gas regulations",
            },
            {
              value: "Item 8",
              text: "CEN and CENELEC",
            },
            {
              value: "Item 9",
              text: "WEEE Label",
            },
            {
              value: "Item 10",
              text: "Energy label",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
        {
          type: "boolean",
          name: "producer_question3",
          title:
            "Are you in compliance to government regulations concerning health and safety, trading standards, employment, and environmental management?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question3_comment",
          visibleIf: "{producer_question3} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question3} = true",
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "producer_question4",
          title: "Do you have a training programme for all staff?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question4_comment",
          visibleIf: "{producer_question4} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question4} = true",
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "producer_question5",
          title: "Have you carried out a health and safety risk assessment?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question5_comment",
          visibleIf: "{producer_question5} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question5} = true",
          autoGrow: true,
        },
      ],
    },
    {
      name: "producer_page2",
      visibleIf: "{group} = 'Item 1'",
      title:
        "The Circular Producer · Level 2: Product lifecycle and sustainable design",
      elements: [
        {
          type: "checkbox",
          name: "producer_question6",
          title:
            "Have you included the following criteria in your product life cycle and design?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Clean materials",
            },
            {
              value: "Item 2",
              text: "Renewable materials",
            },
            {
              value: "Item 3",
              text: "Low energy content materials",
            },
            {
              value: "item1",
              text: "Recycled materials",
            },
            {
              value: "item2",
              text: "Recyclable materials",
            },
            {
              value: "item3",
              text: "Alternative production techniques",
            },
            {
              value: "item4",
              text: "Fewer production steps",
            },
            {
              value: "item5",
              text: "Low/clean energy consumption",
            },
            {
              value: "item6",
              text: "Less production waste",
            },
            {
              value: "item7",
              text: "Few/clean production consumables",
            },
            {
              value: "item8",
              text: "Less/clean/reusable packaging",
            },
            {
              value: "item9",
              text: "Energy-efficient transport mode",
            },
            {
              value: "item10",
              text: "Energy-efficient logistics",
            },
            {
              value: "item11",
              text: "Low energy consumption",
            },
            {
              value: "item12",
              text: "Clean energy source",
            },
            {
              value: "item13",
              text: "Few consumables",
            },
            {
              value: "item14",
              text: "Clean consumables",
            },
            {
              value: "item15",
              text: "No wastage of energy or consumables",
            },
            {
              value: "item16",
              text: "Reliability and durability",
            },
            {
              value: "item17",
              text: "Easy maintenance and repair",
            },
            {
              value: "item18",
              text: "Modular product structure",
            },
            {
              value: "item19",
              text: "Classic Design",
            },
            {
              value: "item20",
              text: "Strong product-user relation",
            },
            {
              value: "item21",
              text: "Reuse of product (components)",
            },
            {
              value: "item22",
              text: "Remanufacturing/refurbishing",
            },
            {
              value: "item23",
              text: "Recycling of materials",
            },
            {
              value: "item24",
              text: "Safe incineration",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "producer_page3",
      visibleIf: "{group} = 'Item 1'",
      title: "The Circular Producer · Level 3: WEEE recycling ",
      elements: [
        {
          type: "boolean",
          name: "producer_question7",
          title:
            "Do you control the release of hazardous substances from any equipment you handle?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question7_comment",
          visibleIf: "{producer_question7} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question7} = true",
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "producer_question8",
          title:
            "Are there established protocols in place for the management of hazardous compounds that are removed throughout the recycling procedure?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question8_comment",
          visibleIf: "{producer_question8} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question8} = true",
          autoGrow: true,
        },
        {
          type: "checkbox",
          name: "producer_question9",
          title:
            "Do you comply to current legislation and best practices while managing hazardous waste, including:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "WEEE Directive",
            },
            {
              value: "Item 2",
              text: "Batteries and Accumulators Directive",
            },
            {
              value: "Item 3",
              text: "REACH Regulation",
            },
            {
              value: "Item 4",
              text: "POPs regulation",
            },
            {
              value: "Item 5",
              text: "Basel Convention",
            },
            {
              value: "Item 6",
              text: "Greenhouse gas regulations",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
        {
          type: "boolean",
          name: "producer_question10",
          title:
            "Is the handling of hazardous substances exclusively carried out by appropriately competent and qualified personnel?\n",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question10_comment",
          visibleIf: "{producer_question10} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question10} = true",
          autoGrow: true,
        },
        {
          type: "checkbox",
          name: "producer_question11",
          title:
            "Do you ensure the provision and utilization of suitable equipment for personnel involved in the handling of hazardous chemicals, encompassing:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Goggles",
            },
            {
              value: "Item 2",
              text: "Personal Protection Equipment (PPE)",
            },
            {
              value: "Item 3",
              text: "Rubber-soled shoes",
            },
            {
              value: "Item 4",
              text: "Face masks",
            },
            {
              value: "Item 5",
              text: "Cut-resistant gloves",
            },
            {
              value: "Item 6",
              text: "Hearing protection",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
        {
          type: "boolean",
          name: "producer_question12",
          title:
            "Is personnel training available regarding hazardous substances and the proper procedures for safe manual dismantling?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "producer_question12_comment",
          visibleIf: "{producer_question12} = true",
          title: "Please give details:",
          hideNumber: true,
          requiredIf: "{producer_question12} = true",
          autoGrow: true,
        },
        {
          type: "checkbox",
          name: "producer_question13",
          title:
            "In the case of exporting overseas, have you ensured that the operators:",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Implement measures to mitigate the emission of hazardous substances into the environment.",
            },
            {
              value: "Item 2",
              text: "Comply to the regulations and guidelines set by their respective nations.",
            },
          ],
          showNoneItem: true,
        },
      ],
    },
    {
      name: "user_page1",
      visibleIf: "{group} = 'Item 2'",
      title: "The Circular User · Level 1: Organizational structure and policy",
      elements: [
        {
          type: "checkbox",
          name: "user_question1",
          title:
            "Do you comply to current legislation and best practices while handling and managing hazardous waste, including:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "WEEE Directive",
            },
            {
              value: "Item 2",
              text: "Batteries and Accumulators Directive",
            },
            {
              value: "Item 3",
              text: "CENELEC",
            },
            {
              value: "Item 4",
              text: "REACH Regulation",
            },
            {
              value: "Item 5",
              text: "POPs regulation",
            },
            {
              value: "Item 6",
              text: "Basel Convention",
            },
            {
              value: "Item 7",
              text: "National regulations (e.g. permit and license)",
            },
            {
              value: "Item 8",
              text: "Occupational Health and Safety standards",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "user_page2",
      visibleIf: "{group} = 'Item 2'",
      title:
        "The Circular User · Level 2: Collection and infrastructure for reuse and repair\n",
      elements: [
        {
          type: "checkbox",
          name: "user_question2",
          title:
            "Does your collection facility include the following features:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Provide collection points of WEEE",
            },
            {
              value: "Item 2",
              text: "Provide collection points of WEEE for reuse and repair",
            },
            {
              value: "Item 3",
              text: "Provide Bulky waste collection",
            },
            {
              value: "Item 4",
              text: "Easily accessible collection points",
            },
            {
              value: "Item 5",
              text: "Weatherproof",
            },
            {
              value: "Item 6",
              text: "Adequate facilities for managing leakage of compressor oils, coolant/refrigerant.",
            },
            {
              value: "Item 7",
              text: "Safe storage for batteries, CRT, LCD/LED/Plasma TV, fluorescent and other mercury containing lamps",
            },
            {
              value: "Item 8",
              text: "Specific storage for reuse and repair",
            },
            {
              value: "Item 9",
              text: "Ensure of handling WEEE collected to the state of the art recycling / treatment",
            },
            {
              value: "Item 10",
              text: "Energy-efficient transport mode",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "user_page3",
      visibleIf: "{group} = 'Item 2'",
      title:
        "The Circular User · Level 3: WEEE awareness and networking strategies",
      elements: [
        {
          type: "checkbox",
          name: "user_question3",
          title: "Audience groups:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Consumers",
            },
            {
              value: "Item 2",
              text: "Businesses",
            },
            {
              value: "Item 3",
              text: "Retailers",
            },
            {
              value: "Item 4",
              text: "Recyclers",
            },
            {
              value: "Item 5",
              text: "Relevant authorities",
            },
            {
              value: "Item 6",
              text: "Producers",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "user_question4",
          title: "How information is generating to audience:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Guidelines",
            },
            {
              value: "Item 2",
              text: "Online platform and social media (website, knowledge website)",
            },
            {
              value: "Item 3",
              text: "Communities’ activities (e.g. repair café)",
            },
            {
              value: "Item 4",
              text: "Workshops",
            },
            {
              value: "Item 5",
              text: "Training program",
            },
            {
              value: "Item 6",
              text: "Events, forum, conferences",
            },
            {
              value: "Item 7",
              text: "Integrated in educational program",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "user_question5",
          title:
            "WEEE Awareness topics that covers in your organization include:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "General information of WEEE",
            },
            {
              value: "Item 2",
              text: "Updates of law and regulations related to WEEE management",
            },
            {
              value: "Item 3",
              text: "Environmental and health impact of WEEE",
            },
            {
              value: "Item 4",
              text: "Preparation for WEEE disposal",
            },
            {
              value: "Item 5",
              text: "Responsible disposal of WEEE",
            },
            {
              value: "Item 6",
              text: "Information on collection points",
            },
            {
              value: "Item 7",
              text: "Information on Take-back program and EPR",
            },
            {
              value: "Item 8",
              text: "Information on Reuse and Repair",
            },
            {
              value: "Item 9",
              text: "Case studies and best practices of WEEE management",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "user_question6",
          title: "Cooperation basis:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Regional level",
            },
            {
              value: "Item 2",
              text: "National level",
            },
            {
              value: "Item 3",
              text: "International level",
            },
            {
              value: "Item 4",
              text: "Public Private partnerships",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "reuser_page1",
      visibleIf: "{group} = 'Item 3'",
      title:
        "The Circular Re-user · Level 1: Organizational structure and policy",
      elements: [
        {
          type: "checkbox",
          name: "reuser_question1",
          title:
            "Do you comply to current legislation and best practices for managing hazardous components and waste, which includes:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "WEEE Directive",
            },
            {
              value: "Item 2",
              text: "RoHS Directive",
            },
            {
              value: "Item 3",
              text: "Batteries and Accumulators Directive",
            },
            {
              value: "Item 4",
              text: "Product guidelines",
            },
            {
              value: "Item 5",
              text: "Third party repair guideline (e.g. Ifixit ..)",
            },
            {
              value: "Item 6",
              text: "Occupational Health and Safety",
            },
            {
              value: "Item 7",
              text: "Eco-design Directive",
            },
            {
              value: "Item 8",
              text: "CENELEC",
            },
            {
              value: "Item 9",
              text: "National reuse and repair guidelines",
            },
            {
              value: "Item 10",
              text: "The General Data Protection Regulation (GDPR)",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "reuser_page2",
      visibleIf: "{group} = 'Item 3'",
      title:
        "The Circular Re-user · Level 2: Markets, product support and services\n",
      elements: [
        {
          type: "checkbox",
          name: "reuser_question2",
          title: "The technical services concerns and provide services with:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Skilled technician with qualifications of electrical professionals",
            },
            {
              value: "Item 2",
              text: "Data sanitization",
            },
            {
              value: "Item 3",
              text: "Clear policies and procedures for handling returns, repairs, and warranty claims",
            },
            {
              value: "Item 4",
              text: "Legal guarantee and quality assurance of products",
            },
            {
              value: "Item 5",
              text: "Sustainable packaging",
            },
            {
              value: "Item 6",
              text: "Energy-efficient transport and logistic",
            },
            {
              value: "Item 7",
              text: "Ensure the state of the art of treatment of WEEE when not suitable for reuse and repair",
            },
            {
              value: "Item 8",
              text: "Promote the benefits of repaired and refurbished products",
            },
            {
              value: "Item 9",
              text: "Cooperation with producers, retailers and other stakeholders",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "reuser_page3",
      visibleIf: "{group} = 'Item 3'",
      title: "The Circular Re-user · Level 3: Transitional digitalization",
      elements: [
        {
          type: "checkbox",
          name: "reuser_question3",
          title:
            "Do you have preparation and implementation plan for digital system which include:\n",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Connecting to repair network in the regional, national level",
            },
            {
              value: "Item 2",
              text: "Digital system for tracking and managing inventory",
            },
            {
              value: "Item 3",
              text: "Digital platform for reporting of WEEE reuse and repair",
            },
            {
              value: "Item 4",
              text: "System support for Digital product passport",
            },
            {
              value: "Item 5",
              text: "Digital communication channels for customers engagement and awareness",
            },
            {
              value: "Item 6",
              text: "Foster collaboration and data sharing among stakeholders in the WEEE reuse and repair",
            },
            {
              value: "Item 7",
              text: "Encourage innovation and experimentation with new digital technologies, solutions, and business models to address emerging challenges and opportunities in WEEE reuse and repair",
            },
          ],
          showNoneItem: true,
          colCount: 2,
        },
      ],
    },
    {
      name: "admin_page1",
      visibleIf: "{group} = 'Item 4'",
      title: "Public Administration",
      elements: [
        {
          type: "boolean",
          name: "admin_question1",
          title:
            "Are you in compliance to government regulations concerning health and safety, trading standards, employment, and environmental management?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question1_comment",
          visibleIf: "{admin_question1} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question1} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "admin_question2",
          title: "Do you have a training programme for all staff?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question2_comment",
          visibleIf: "{admin_question2} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question2} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "admin_question3",
          title: "Have you carried out a health and safety risk assessment?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question3_comment",
          visibleIf: "{admin_question3} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question3} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "admin_question4",
          title:
            "Do you control the release of hazardous substances from any equipment you handle?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question4_comment",
          visibleIf: "{admin_question4} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question4} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "admin_question5",
          title:
            "Are there established protocols in place for the management of hazardous compounds that are removed throughout the recycling procedure?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question5_comment",
          visibleIf: "{admin_question5} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question5} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "admin_question6",
          title:
            "Is the handling of hazardous substances exclusively carried out by appropriately competent and qualified personnel?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question6_comment",
          visibleIf: "{admin_question6} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question6} = true",
          maxLength: 5000,
          autoGrow: true,
        },
        {
          type: "boolean",
          name: "admin_question7",
          title:
            "Is personnel training available regarding hazardous substances and the proper procedures for safe manual dismantling?",
          isRequired: true,
        },
        {
          type: "comment",
          name: "admin_question7_comment",
          visibleIf: "{admin_question7} = true",
          title: "Please give details",
          hideNumber: true,
          requiredIf: "{admin_question7} = true",
          maxLength: 5000,
          autoGrow: true,
        },
      ],
    },
  ],
  showTitle: false,
  showCompletedPage: false,
  showProgressBar: "bottom",
  progressBarType: "questions",
  clearInvisibleValues: "onHiddenContainer",
  autoGrowComment: true,
  firstPageIsStarted: true,
  widthMode: "responsive",
};
